import React from 'react';
import Card from '../../../components/Card';
import { TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Badge from '../../../components/Badge';
import { faClock, faListCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import moment from 'moment';

interface Props {
    activity: ActivityAndService;
    onEdit: () => void;
}

export default function ActivityAndServiceCard({ activity, onEdit }: Props) {
    const { styles, theme } = useStyles(styleSheet);

    return (
        <Card>
            <TouchableOpacity onPress={onEdit}>
                <View style={styles.topRow}>
                    <Badge
                        mode='ROUNDED'
                        color='blue'
                        textColor={theme.colors.badges.blue.textColor}
                    >{activity.indicator.code}</Badge>
                </View>
                <MyAppText style={styles.address} numberOfLines={1}>
                    {activity.address}
                    {activity.number ? `, ${activity.number}` : ''}
                </MyAppText>

                <View style={styles.timeRow}>
                    <FontAwesomeIcon icon={faClock} fontSize={14} color={theme.colors.neutral['500']} />
                    <MyAppText style={styles.timeText}>
                        {moment(activity.startDate).format('HH:mm')} – {moment(activity.endDate).format('HH:mm')}
                    </MyAppText>
                </View>

                <View style={styles.bottomRow}>
                    <View style={styles.stats}>
                        <View style={styles.stat}>
                            <FontAwesomeIcon icon={faListCheck} fontSize={14} color={theme.colors.neutral['500']} />
                            <MyAppText style={styles.statText}>
                                {activity.actionsQty} {activity.actionsQty === 1 ? translate('action') : translate('actions')}
                            </MyAppText>
                        </View>
                        <View style={styles.stat}>
                            <FontAwesomeIcon icon={faUsers} fontSize={14} color={theme.colors.neutral['500']} />
                            <MyAppText style={styles.statText}>{activity.publicQty} {translate('people')}</MyAppText>
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
        </Card>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    topRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    address: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.field.text,
        marginBottom: 6,
    },
    cep: {
        fontWeight: '400',
        color: theme.colors.neutral['400'],
    },
    timeRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        marginBottom: 10,
    },
    timeText: {
        fontSize: 13,
        color: theme.colors.neutral['500'],
    },
    bottomRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    stats: {
        flexDirection: 'row',
        gap: 14,
    },
    stat: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    statText: {
        fontSize: 12,
        color: theme.colors.neutral['500'],
    },
    document: {
        fontSize: 11,
        color: theme.colors.neutral['400'],
        fontFamily: 'monospace',
    },
}));
